// ACCESS COMPONENTS
import { defineAsyncComponent } from 'vue'

export const LegalModalComponent = defineAsyncComponent(() => import('./legal-modal-component.vue'))
export const LoadMoreComponent = defineAsyncComponent(() => import('./load-more-component.vue'))
export const SignInFormComponent = defineAsyncComponent(() => import('./sign-in-form-component.vue'))
export const OtpComponent = defineAsyncComponent(() => import('./otp-component.vue'))